import { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Box } from '@mui/material'

import TableView, { useTable, IColumn } from 'packages/ui/Table'
import ScrollTable from 'components/global/CUK/ScrollTable'
import EmptyScreen from 'packages/ui/EmptyScreen'

import { usePhoneNumbers } from './use-queries'

const COLUMNS_CONFIG: IColumn[] = [
  {
    name: 'context',
    header: {
      label: ctx => ctx.t('voip.phone_numbers.number')
    },
    value: ({context, number}) => <Stack><Box sx={{fontWeight: 500}}>{context as string}</Box>{<Box>{number as string}</Box>}</Stack>,
    sortable: true
  }, {
    name: 'destination_type',
    header: {
      label: ctx => ctx.t('voip.phone_numbers.destination')
    },
    value: ({destination_type}) => {
      const {t} = useTranslation()
      return t(`voip.phone_numbers.${destination_type}`)
    },
    sortable: true
  }, {
    name: 'destination',
    header: {
      label: ctx => ctx.t('voip.phone_numbers.detail')
    },
    value: ({destination_type, destination}) => {
      if (destination_type === 'ivr_custom_menu') {
        return '-'
      } else {
        return destination as string
      }
    },
    sortable: true
  }
]

const PhoneNumbers = () => {
  const {loading, phoneNumbers} = usePhoneNumbers()
  const {t} = useTranslation()
  const [sort, setSort] = useState<{by: string, direction: string}>({by: 'context', direction: 'asc'})
  
  const items = useMemo(() => {
    return [...phoneNumbers].sort((a, b) => {
      const valueA = a[sort.by] || '';
      const valueB = b[sort.by] || '';
      return sort.direction === 'asc' ? 
        valueA.localeCompare(valueB) : 
        valueB.localeCompare(valueA);
    })
  }, [sort, phoneNumbers])

  const apiTable = useTable({
    rowKey: 'number',
    items,
    loading,
    columns: COLUMNS_CONFIG
  })

  if (!loading && (!phoneNumbers || phoneNumbers.length === 0)) {
    return (
      <Stack 
        sx={{
          height: 'calc(100cqh - 446px)',
          border: '1px dashed #D7DAEA',
          borderRadius: '24px',
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <EmptyScreen icon={'phone-volume'} variant="compact">
          {t('voip.phone_numbers.no_items')}
        </EmptyScreen>
      </Stack>
    )
  }

  return (
    <Stack sx={{ height: 'calc(100cqh - 446px)' }}>
      <ScrollTable shouldFetchNextPage={false}>
        <TableView
          apiTable={apiTable}
          view={'card'}
          sort={{
            ...sort,
            onChange: (name) => {
              setSort({
                by: name,
                direction: name === sort.by ? sort.direction === 'asc' ? 'desc' : 'asc' : 'asc'
              })
            }
          }}
          noItemsMessage={t('voip.phone_numbers.no_items')}
        />
      </ScrollTable>
    </Stack>
  )
}

export default PhoneNumbers